import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { pt } from "@/i18n/pt";
import { en } from "@/i18n/en";
import { es } from "@/i18n/es";

const dicts = { pt, en, es };
const I18nCtx = createContext(null);

function get(obj, path) {
  return path.split(".").reduce((a, k) => (a && a[k] !== undefined ? a[k] : null), obj);
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("adlib_lang") || "pt");

  useEffect(() => {
    localStorage.setItem("adlib_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useMemo(() => {
    return (key, vars) => {
      const raw = get(dicts[lang] || dicts.pt, key) ?? get(dicts.en, key) ?? key;
      if (!vars) return raw;
      return String(raw).replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? "");
    };
  }, [lang]);

  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nCtx);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
}
